import { Breadcrumb, Button, Card, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import NewsListTable from "components/table/NewsListTable";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import styles from "../styles/NewList.module.css";
import NewAndPolicyFilters from "./NewAndPolicyFilter";
const NewsList = ({
  isLoading = {},
  pagination = {},
  newsList = [],
  rolePermissionOptions = [],
  announcementByOptions = [],
  modifiedEmployeeOptions = [],
  onCreate = () => { },
  onEdit = () => { },
  onSearch = () => { },
  onCancel = () => { },
  onChange = () => { },
  onStatus = () => { },
}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  return (
    <MainLayout>
      <Space className={styles.container} direction="vertical" size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("news_policy.header"), href: "" },
            { title: t("news_list.header") },
          ]} />
          <h2>{t("news_list.header")}</h2>
        </Flex>
        <Row justify="end">
          <Space direction="horizontal" size={10}>
            <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ height: "40px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {
              roles.includes("CREATE_NEWS_&_POLICY|NEWS") && <Button onClick={onCreate} style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", height: "40px", borderRadius: "8px" }}>
                <Flex gap={8}>
                  <CreateIcon />
                  {t("common.create")}
                </Flex>

              </Button>
            }

          </Space>
        </Row>
        {useFilter && (
          <Card style={{ border: "1px solid #EAECF0", }}>
            <NewAndPolicyFilters
              isLoading={isLoading}
              pagination={pagination}
              dataSource={newsList}
              announcementByOptions={announcementByOptions}
              rolePermissionOptions={rolePermissionOptions}
              employeeOptions={modifiedEmployeeOptions}
              onEdit={onEdit}
              dataFlag={"new"}
              onCancel={onCancel}
              onChange={onChange}
              onSearch={onSearch}
            />
          </Card>)}
        <NewsListTable
          isLoading={isLoading}
          pagination={pagination}
          dataSource={newsList}
          onEdit={onEdit}
          onCancel={onCancel}
          onChange={onChange}
          onStatus={onStatus}
        />
      </Space>
    </MainLayout>
  );
};

export default NewsList;
